/**
 * GiftCategoryListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  Table,
  Pagination,
  SelectDepth,
} from 'components';
import { Button, Input, Select } from 'antd';
import moment from 'moment';
import { PlusOutlined } from '@ant-design/icons';

const depthItem = [1, 2, 3, 4, 5].map((_i1) => ({
  key: `${_i1}`,
  title: `대분류 ${_i1}`,
  children: [1, 2, 3, 4, 5].map((_i2) => ({
    key: `${_i1}-${_i2}`,
    title: `중분류 ${_i1}-${_i2}`,
    children: [1, 2, 3, 4, 5].map((_i3) => ({
      key: `${_i1}-${_i2}-${_i3}`,
      title: `중소분류 ${_i1}-${_i2}-${_i3}`,
      children: [1, 2, 3, 4, 5].map((_i4) => ({
        key: `${_i1}-${_i2}-${_i3}-${_i4}`,
        title: `소분류 ${_i1}-${_i2}-${_i3}-${_i4}`,
      })),
    })),
  })),
}));

const GiftCategoryListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedKey, setSelectedKey] = useState([]);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  // for (let i = 0; i < 10; i++) {
  //   newData.push({
  //     상품번호: '000000',
  //     분류: 'N',
  //     유효기간: new Date(),
  //     선물카테고리: `가정의 달`,
  //     상품카테고리: `커피 > 원두`,
  //     전시여부: `N`,
  //     상품명: `아라비카원두`,
  //     연락처: '010-1234-1234',
  //   });
  // }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>선물 카테고리 관리</Title>

          <Content maxWidth={'100%'} borderRadius={4}>
            <div>
              <Select
                size="large"
                value={'카테고리 검색으로 변경'}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="카테고리명을 입력해주세요."
                style={{ ...styles.form.input.large, width: 400 }}
              />
            </div>

            <div style={{ marginTop: 20 }}>
              <SelectDepth
                items={depthItem}
                onSelect={(data) => setSelectedKey(data)}
                onFinish={({ title }) => console.log('finish', title)}
              />
            </div>
            <div style={{ marginTop: 20, display: 'flex' }}>
              {Array.from({
                length: selectedKey.length + 1 < 4 ? selectedKey.length + 1 : 4,
              }).map((_item, _index) => (
                <div
                  style={{
                    width: '25%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button type="primary" icon={<PlusOutlined />} />
                </div>
              ))}
            </div>
          </Content>
          <div
            style={{
              marginTop: 20,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button size="small" style={{ marginRight: 8 }}>
              카테고리 수정
            </Button>
            <Button
              size="small"
              type="primary"
              style={{ background: 'var(--primary-color)' }}
            >
              카테고리 삭제
            </Button>
          </div>

          <Content maxWidth={'100%'} style={{ marginTop: 40 }} borderRadius={4}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                총 <span>0</span>개
              </h4>
              <Button type="primary" style={{ marginRight: 8 }}>
                상품 추가
              </Button>
            </div>
            <Table
              data={newData}
              columns={[
                {
                  title: '상품 번호',
                  key: '상품번호',
                },
                {
                  title: '분류',
                  key: '분류',
                  render: (item) => (
                    <span
                      style={{
                        padding: 7,
                        border: '0.5px solid #B2B2B2',
                        borderRadius: 4,
                      }}
                    >
                      {item}
                    </span>
                  ),
                },
                {
                  title: '유효기간',
                  key: '유효기간',
                  render: (item) => moment(item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '선물 카테고리',
                  key: '선물카테고리',
                },
                {
                  title: '상품 카테고리',
                  key: '상품카테고리',
                },
                {
                  title: '전시여부',
                  key: '전시여부',
                },
                {
                  title: '상품 명',
                  key: '상품명',
                  render: (item) => (
                    <button
                      style={{
                        border: 'none',
                        background: 'none',
                        textDecoration: 'underline',
                        color: '#1C6BFF',
                        cursor: 'pointer',
                      }}
                    >
                      {item}
                    </button>
                  ),
                },
                {
                  title: '연락처',
                  key: '연락처',
                },
                {
                  title: '비고',
                  key: '비고',
                  render: () => (
                    <>
                      <Button
                        size="small"
                        style={{
                          borderColor: 'var(--primary-color)',
                          color: 'var(--primary-color)',
                          marginRight: 4,
                        }}
                      >
                        수정
                      </Button>
                      <Button
                        size="small"
                        style={{ borderColor: '#EE4700', color: '#EE4700' }}
                      >
                        삭제
                      </Button>
                    </>
                  ),
                },
              ]}
            />
            <Pagination total={40} style={{ marginTop: 40 }} />
          </Content>
        </Col>
      </Row>
    </Content>
  );
};

export default GiftCategoryListPresenter;
